import { render, staticRenderFns } from "./add_edit_modal.vue?vue&type=template&id=2dad490f&scoped=true"
import script from "./add_edit_modal.vue?vue&type=script&lang=js"
export * from "./add_edit_modal.vue?vue&type=script&lang=js"
import style0 from "./add_edit_modal.vue?vue&type=style&index=0&id=2dad490f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad490f",
  null
  
)

export default component.exports